module.exports = __webpack_public_path__ + "img/bghe66.586b047e.png";